import { createSelector } from '@ngrx/store';

import { getCurrentRoute } from '../getCurrentRoute';

export const isCurrentRouteLoyalty = createSelector(getCurrentRoute, (current) => current?.url === '/loyalty');
